import React from 'react';
import { createMachine } from 'xstate';
import { Model } from 'xstate/lib/model.types';
import { BaseContext, BaseEvent, customElement, remoteMessage } from '../../../machine';
import { ReminderSavingsCard } from '../ZoryveDirect.components';

const WELCOME = 'WELCOME';
const REMINDER_SAVINGS_CARD = 'REMINDER_SAVINGS_CARD';
const QUESTIONS = 'QUESTIONS';

export const WELCOME_MESSAGES = {
  WELCOME:
    'Thank you for your interest in enrolling in the ZORYVE Direct Program! First, let\'s make sure that you\'re eligible for great savings.',
  REMINDER_SAVINGS_CARD: <ReminderSavingsCard />,
  QUESTIONS:
    'Questions? Call 1-844-979-1288 from 6:00 am–5:00 pm PT, M–F. Text STOP to unsubscribe. Text TERMS for Terms and Conditions to 1-440-496-7983.',
};

/**
 * ZORYVE Direct Program Flow V2.0
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const ZoryveDirectWelcomeFlow = (
  model: Model<BaseContext, BaseEvent, void>,
  initial = WELCOME
) =>
  createMachine<BaseContext, BaseEvent>({
    id: 'ZoryveDirectWelcomeFlow',
    initial: initial ?? WELCOME,
    context: model.initialContext,
    states: {
      // Welcome Message
      [WELCOME]: remoteMessage({
        id: WELCOME,
        message: WELCOME_MESSAGES.WELCOME,
        nextState: REMINDER_SAVINGS_CARD,
      }),

      [REMINDER_SAVINGS_CARD]: customElement({
        id: REMINDER_SAVINGS_CARD,
        jsx: WELCOME_MESSAGES.REMINDER_SAVINGS_CARD,
        nextState: QUESTIONS,
      }),

      [QUESTIONS]: remoteMessage({
        id: QUESTIONS,
        message: WELCOME_MESSAGES.QUESTIONS,
      }),
    },
  });
